import React from 'react';
import Video from './assets/ParroquiaChinacota/Video.mp4';
const ParroquiaChinacota = () => {
  return (
    <div className="container">
      <h2>
        ✅ Proyecto: Parroquia San Juan Bautista de Chinácota🌞✨
             </h2>
      <p>
                <video controls>
          <source src={Video} type="video/mp4" />
          Tu navegador no soporta la reproducción de video.
        </video>

 <span className='highlight'> Energía solar al servicio de grandes espacios: potencia, eficiencia y sostenibilidad para respaldar las actividades comunitarias.</span>


 <br/> <br/>En la Parroquia San Juan Bautista instalamos un sistema solar fotovoltaico conectado a la red con una capacidad de 19.6 kWp, compuesto por 28 paneles solares de alta eficiencia y un inversor multicadena de 20 kW, una tecnología robusta y confiable diseñada para gestionar mayores cargas eléctricas y garantizar estabilidad en edificaciones de uso continuo.

<br/><br/>Gracias a esta solución, el sistema abastece de manera eficiente los consumos esenciales de la parroquia <span className='highlight'>iluminación general, equipos de sonido, oficinas, salones y áreas de reunión</span> reduciendo significativamente la demanda de energía de la red y optimizando los costos de operación del espacio religioso.

<br/><br/>Los objetivos de este proyecto fueron:

<br/><br/>✔ Reducir los costos de energía generados por la operación diaria de la parroquia
<br/>✔ Implementar una solución sostenible acorde con el compromiso social y ambiental de la comunidad
<br/>✔ Garantizar energía constante y segura para ceremonias, reuniones y actividades parroquiales

<br/><br/>Hoy, la Parroquia San Juan Bautista genera una parte fundamental de su energía limpia, logrando ahorros considerables en su factura eléctrica mensual y asegurando un funcionamiento más autónomo y sostenible. La instalación también incrementa el valor y la eficiencia energética de la infraestructura parroquial.

<br/><br/>Esta obra se convierte en un referente regional de responsabilidad ambiental y modernización energética al servicio de la comunidad.

<br/><br/>Este proyecto cuenta con el acompañamiento de IPSUM Ingeniería e Innovación, ofreciendo:

<br/><br/>🔧 Soporte técnico y mantenimiento preventivo.
<br/>🔧 Monitoreo del sistema para garantizar el máximo rendimiento.
<br/>🔧 Instalación estructural segura, diseñada para la durabilidad, eficiencia del sistema y facilitar su mantenimiento.
<br/>🔧 Capacitación al personal en el uso de la plataforma de monitoreo.
<br/>🔧 Acompañamiento presencial de nuestros ingenieros durante y después de la instalación.

<br/><br/>Una decisión estratégica que combina sostenibilidad, ahorro y compromiso con la comunidad.

      </p>
    </div>
  );
};

export default ParroquiaChinacota;
